import { render } from "./CratesSummary.vue?vue&type=template&id=5f2b1789"
import script from "./CratesSummary.vue?vue&type=script&lang=js"
export * from "./CratesSummary.vue?vue&type=script&lang=js"
script.render = render

export default script